// src/api.js
import axios from "axios";
import API_URL from "./config";

console.log("Frontend API URL:", API_URL);

const api = axios.create({
  baseURL: API_URL,
});

// Optional: attach JWT automatically if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
